import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ApiPublicGuideService } from '../../../core/services/api/PublicGuide/api-public-guide';
import { PublicGuideListItem } from '../../../core/models/public-guide.model';
import { ManualHeroComponent } from '../manual-hero/manual-hero.component';

@Component({
  selector: 'app-manual-guides',
  standalone: true,
  imports: [CommonModule, RouterLink, ManualHeroComponent],
  templateUrl: './manual-guides.component.html',
  styleUrl: './manual-guides.component.css',
})
export class ManualGuidesComponent implements OnInit {
  private readonly api = inject(ApiPublicGuideService);
  private readonly route = inject(ActivatedRoute);

  items = signal<PublicGuideListItem[]>([]);
  isLoading = signal(false);
  error = signal<string | null>(null);
  kind = signal<'parking' | 'ev'>('parking');

  ngOnInit(): void {
    const raw = (this.route.snapshot.paramMap.get('kind') || 'parking').toLowerCase();
    const kind = raw === 'ev' ? 'ev' : 'parking';
    this.kind.set(kind);
    this.load(kind);
  }

  title(): string {
    return this.kind() === 'ev' ? 'คู่มือ EV Charger' : 'คู่มือ Parking';
  }

  load(kind: 'parking' | 'ev'): void {
    this.isLoading.set(true);
    this.error.set(null);
    this.api.getPublicGuides(kind).subscribe({
      next: (rows) => {
        this.items.set(rows);
        this.isLoading.set(false);
      },
      error: () => {
        this.error.set('โหลดคู่มือไม่สำเร็จ');
        this.isLoading.set(false);
      },
    });
  }
}
